<template>
  <div>
    <div v-if="excess === '1'"></div>
    <div v-else>
      <div v-if="isShowTadSim" style="height: calc(100vh - 120px);">
        <div style="height: 100%; display: grid; justify-content: center; align-content: center; font-size: 30px;">
          本阶段仅供联合汽车电子有限公司内部员工和受邀人员使用
        </div>
      </div>
      <div v-else>
        <el-row class="alignSelf" :gutter="6" style="padding: 9px 0 13px 17px">
          <el-col class="alignSelf" :span="0.5"><img src="../../../assets/img/pages/ru.png" height="26" width="26"/></el-col>
          <el-col style="display: flex">
            <el-breadcrumb separator-class="el-icon-arrow-right" style="align-items: center;display: flex;align-items: center;">
              <el-breadcrumb-item style="color: #2F374B;font-size: 18px">车载应用开发工具</el-breadcrumb-item>
            </el-breadcrumb>
          </el-col>
        </el-row>
        <div style="padding: 7px 0 13px 17px;display: flex;">
          <el-button class="buttonClass" :disabled="loadTemplateFlag" @click="openSelectTemplateDialog">
            <i class="el-icon-circle-plus buttonIconClass">
              <span class="buttonNameClass">应用</span>
            </i>
          </el-button>
          <el-button @click="addCatalogueDialog=true" class="buttonClass">
            <i class="el-icon-circle-plus buttonIconClass">
              <span class="buttonNameClass">目录</span>
            </i>
          </el-button>
          <el-button @click="goConfiguration()" class="buttonClass">
            <span class="bconfigurationButtonClass">系统配置</span>
          </el-button>
          <div style="float: right;width: 100%">
            <div style="float: right;font-size: 14px;color: #2F374B">
              <el-input
                  type="text"
                  v-model="appName"
                  prefix-icon="el-icon-search"
                  placeholder="请输入关键词"
                  style="width: 270px; cursor: pointer"
                  clearable
                  @keyup.enter.native="getList"
              ></el-input>
              <div style="float: right;padding: 0 29px 0 10px">
                <el-button style="color: #fff;background-color: #4d78ff;border-color: #4d78ff;width: 70px;height: 40px" @click="getList()">搜索</el-button>
              </div>
            </div>
          </div>
        </div>
        <el-row style="padding: 20px 0 0 17px" :gutter="20">
          <el-col v-for="(item,index) in list" :key="index" style="padding-bottom: 10px;width: 270px;">
            <el-card class="appListCard" :body-style="{ padding: '11px 10px' }" >
              <img :src="item.logoUrl ? item.logoUrl : 'https://test-biz-pub-1314150920.cos.ap-shanghai.myqcloud.com/web/img/list-default.png'" v-if="item.type === '1'" @click="goDetails(item)" class="image" alt=""/>
              <img :src="item.logoUrl ? item.logoUrl : 'https://test-biz-pub-1314150920.cos.ap-shanghai.myqcloud.com/web/customize/catalogue.png'" v-if="item.type === '0'" @click="goDetails(item)" class="image" alt=""/>
              <div style="margin-top: 12px">
                <div style="display: flex;align-items: center;position: relative;">
                  <div @click="goDetails(item)" class="cardName">
                    <div v-html="item.keyword ? item.keyword : item.name"> </div>
                  </div>
                  <div class="dropdownDiv" v-if="item.type === '0'" >
                    <el-dropdown placement="top-end">
                      <div style="font-size: 21px;cursor: pointer;align-self: center;display: flex;">
                        <img src="../../../assets/img/pages/she.png" height="22" width="22"/>
                      </div>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="a" style="color: #2F374B" @click.native="cataloguePropertiesView(item)">属性</el-dropdown-item>
                        <el-dropdown-item command="d" style="color: #FF0000" @click.native="isDelect(item)">删除</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                  <div class="dropdownDiv" v-else>
                    <el-dropdown placement="top-end">
                      <div style="font-size: 21px;cursor: pointer;align-self: center;display: flex;">
                        <img src="../../../assets/img/pages/she.png" height="22" width="22"/></div>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="b" style="color: #2F374B" @click.native="goHistoricalData(item.id)">历史测试报告</el-dropdown-item>
                        <el-dropdown-item command="a" style="color: #2F374B" @click.native="cataloguePropertiesView(item)">属性</el-dropdown-item>
                        <el-dropdown-item command="b" style="color: #2F374B" @click.native="cloneSceneConfirm(item.id)">克隆</el-dropdown-item>
                        <el-dropdown-item command="c" style="color: #2F374B" @click.native="changeMoveCatalogueDialogVisible(item)">移动到目录</el-dropdown-item>
                        <el-dropdown-item command="d" style="color: #FF0000" @click.native="isDelect(item)">删除</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div>
                <div class="bottom clearfix">
                  <icon class="el-icon-time" style="font-size: 14px"></icon>
                  <time class="time">上次修改:{{gainDataTime(item.updateTimeVo ? item.updateTimeVo : item.updateTime)}}</time>
                </div>
                <div style="margin-top: 10px;justify-content: space-between;display: flex;height:30px;position: relative;">
                  <div style="display: inline-grid;" v-if="item.type === '1'">
                    <div class="pointClass">
                      {{getStageStatusName(item.stageStatus)}}
                    </div>
                  </div>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
        <el-dialog
          :visible.sync="addCatalogueDialog"
          top="200px"
          width="860px"
          center
          :before-close="handleClose"
          @opened="autofocusDialogRef('catalogueName')">
          <div style="width: 100%;height: 50px;text-align: center;letter-spacing: 1px;">
            <span style="font-size: 18px;color: #2F374B;">新建目录</span>
          </div>
          <el-form :model="addCatalogueForm" :rules="catalogueFormRules" ref="addCatalogueForm" >
            <el-row>
              <el-col style="text-align: center">
                <el-form-item label="目录名称：" prop="catalogueName" style="display: inline-flex;">
                  <el-input ref="catalogueName" style="width: 246px;" v-model="addCatalogueForm.catalogueName" placeholder="请输入目录名称" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="padding-top: 41px">
              <el-col style="text-align: center">
                <el-button type="primary" @click="addCatalogueFunction('addCatalogueForm')" class="confirmButton" round>确 定</el-button>
                <el-button @click="cancelCatalogueFunction()" class="cancelButton" round>取 消</el-button>
              </el-col>
            </el-row>
          </el-form>
        </el-dialog>
        <el-dialog
            title=""
            :visible.sync="cataloguePropertiesDialogVisible"
            top="200px"
            width="860px"
            center
            @opened="autofocusDialogRef('cataloguePropertiesNewName')">
            <div style="width: 100%;height: 50px;text-align: center;letter-spacing: 1px;">
              <span style="font-size: 18px;color: #2F374B;">属性</span>
            </div>
            <el-form :model="catalogueProperties" :rules="cataloguePropertiesRules" ref="catalogueProperties" >
              <el-row>
                <el-col style="text-align: center">
                  <el-form-item :label="catalogueProperties.type === '0'? '目录名称：' : '应用名称：'" prop="newName" style="display: inline-flex;">
                    <el-input ref="cataloguePropertiesNewName" style="width: 246px;" v-model="catalogueProperties.newName" ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="catalogueProperties.type === '1'">
                <el-col style="text-align: center">
                  <el-form-item label="应用分类：" style="display: inline-flex;">
                    <el-select v-model="catalogueProperties.appType" clearable placeholder="未分类" style="width: 246px">
                      <el-option
                          v-for="item in options"
                          :key="item.tagId"
                          :label="item.tagName"
                          :value="item.tagName">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col style="text-align: center">
                  <el-form-item :label="catalogueProperties.type === '0'? '目录内容：' : '应用内容：'" style="display: inline-flex;">
                     <el-input
                        resize="none"
                        type="textarea"
                        :rows="3"
                        placeholder="请输入内容"
                        style="width: 246px"
                        v-model="catalogueProperties.newDescribes">
                      </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col style="text-align: center">
                  <el-form-item :label="catalogueProperties.type === '0'? '目录图标：' : '应用图标：'" style="display: inline-flex;padding-left: 240px;white-space:nowrap;">
                    <div style="display:flex;width: 506px">
                      <el-upload
                        :limit="1"
                        :before-upload="beforeUpload"
                        list-type="picture-card"
                        action=""
                        :http-request="cutomUpload"
                        :file-list="fileList"
                        :on-exceed="handleExceed"
                        >
                          <i slot="default" class="el-icon-plus"></i>
                          <div slot="file" slot-scope="{file}">
                            <img class="el-upload-list__item-thumbnail" :src="catalogueProperties.newLogoUrl">
                            <span class="el-upload-list__item-actions">
                              <!-- <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                                <i class="el-icon-zoom-in"></i>
                              </span> -->
                              <span class="el-upload-list__item-delete" @click="handleRemove(file)">
                                <i class="el-icon-delete"></i>
                              </span>
                            </span>
                          </div>
                      </el-upload>
                      <el-dialog :visible.sync="uploadDialogVisible" >
                        <img width="100%" :src="dialogImageUrl" alt>
                      </el-dialog>
                    </div>
                    <div style="font-size: 12px;text-align: left;line-height: 20px;">
                      <span>图片格式：png、jpg、jpeg，且不超过500kb，</span><br>
                      <span>最多上传一张图片,建议尺寸：230 X 150 px</span>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row style="padding-top: 41px">
                <el-col style="text-align: center">
                  <el-button type="primary" @click="catalogueUpdate('catalogueProperties')" class="confirmButton" round>确 定</el-button>
                  <el-button @click="cancelCatalogueUpdate()" class="cancelButton" round>取 消</el-button>
                </el-col>
              </el-row>
            </el-form>
        </el-dialog>
        <el-dialog
          title=""
          :visible.sync="movCatalogueDialogVisible"
          :before-close="handleClose"
          width="45%"
          center>
          <div style="text-align:center;">
            <div class="allDirectoryHeader">
              <span style="font-size: 18px;font-weight: 400;color: #000000;">将场景</span>
              <div class="directoryName" v-text="catalogueFrom.name">
              </div>
              <span style="font-size: 18px;font-weight: 400;color: #000000;">移动至目录</span>
            </div>
            <div class="moveDialogDiv">
              <el-radio-group v-model="catalogueFrom.catalogueRadio" style="padding:22px;display: grid;" @change="updateCatalogue">
                <el-radio style="padding-top:10px" :label="catalogueItem.id" v-for="(catalogueItem,catalogueIndex) in catalogueLsit" :key="catalogueIndex" >{{catalogueItem.catalogueName}}</el-radio>
              </el-radio-group>
            </div>
            <el-button type="primary" @click="determineMoveCatalogue()" class="confirmButton" round>确 定</el-button>
            <el-button @click="cancelMoveCatalogue()" class="cancelButton"  round>取 消</el-button>
          </div>
        </el-dialog>
        <!-- 选择模板或应用示例 -->
        <el-dialog
            :visible.sync="selectModelDialogVisible"
            top="20px"
            width="1100px"
        >
          <template slot="title">
            <el-row type="flex" justify="space-between">
              <el-col :span="12">
                <span style="font-size: 18px;font-weight: bold;line-height: 32px;">选择模板或应用示例</span>
              </el-col>
              <el-col :span="12" style="text-align: right">
                <el-button type="primary" size="small" @click="createTemplate">创建</el-button>
              </el-col>
            </el-row>
          </template>
          <TemplateAndExampleGroup :data="templateGroups" :default-app-logo-url="defaultAppLogoUrl" @select-template="selectTemplate"/>
        </el-dialog>
        <div v-if="list.length < 1" style="width: 100%;height: 600px;display: flex;align-items: center;justify-content: center;">
          <img src="../../../assets/img/pages/nodata.png" height="300" width="300"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getProfessionalLevelLsit,
  addCatalogue,
  delCatalogue,
  delApp,
  selectCatalogue,
  appMove,
  appCloneScene,
  catalogueUpdate,
  addorupdata,
  moduleRela,
  isShowTadSim,
  selectAppModel
} from '@/api/modules/professionalLevel'
import { mapGetters } from 'vuex'
import { getDataTime } from '@/scripts/dataTimeUtils'
import COS from 'cos-js-sdk-v5'
import { getUploadKey } from '@/api/modules/api'
import { getLabel } from '@/api/modules/forum'
import TemplateAndExampleGroup from '@/components/templatesAndExamples/group.vue'
export default {
  name: 'Professional',
  components: {
    TemplateAndExampleGroup
  },
  data() {
    const validateInputSpecialKey = (rule, value, callback) => {
      if (!this.checkSpecialKey(value)) {
        callback(new Error('不能含有特殊字符！！'))
      }
      else {
        callback()
      }
    }
    return {
      host: location.hostname === 'localhost' ? 'https://usp-test.uaes.com' : '',
      options: [],
      addCatalogueDialog: false,
      movCatalogueDialogVisible: false,
      cataloguePropertiesDialogVisible: false,
      list: [
      ],
      dialogImageUrl: '',
      uploadDialogVisible: false,
      addCatalogueForm: {
        catalogueName: ''
      },
      catalogueLsit: [],
      catalogueFrom: {
        id: '',
        name: '',
        catalogueRadio: ''
      },
      catalogueProperties: {
        id: '',
        type: '',
        appType: '',
        newName: '',
        newDescribes: '',
        newLogoKey: '',
        newLogoUrl: ''
      },
      appName: '',
      fileList: [],
      catalogueFormRules: {
        catalogueName: [
          { required: true, message: '请输入目录名称', trigger: 'blur' },
          { max: 20, message: '长度在20以内的字符', trigger: 'blur' },
          { validator: validateInputSpecialKey, trigger: 'change' }
        ]
      },
      cataloguePropertiesRules: {
        newName: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          { validator: validateInputSpecialKey, max: 20, message: '长度在20以内的字符', trigger: 'blur' }
        ], newDescribes: [
          { message: '请输入目录介绍', trigger: 'blur' },
          { validator: validateInputSpecialKey, trigger: 'change' }
        ]
      },
      isShowTadSim: false,
      excess: '1',
      selectModelDialogVisible: false,
      selectedTemplate: { id: -1, appName: '空模板', type: 1 },
      defaultAppLogoUrl: 'https://test-biz-pub-1314150920.cos.ap-shanghai.myqcloud.com/web/img/list-default.png',
      templateGroups: [
        // { id: 1, name: '模板', options: [] }
      ],
      loadTemplateFlag: false
    }
  },
  computed: {
    ...mapGetters({
      getUserInfo: 'userAuth/getUsersCurrentInfo'
    }),
    showPage() {
      return !!this.getUserInfo || this.$route.meta.noAuth
    }
  },
  async created() {
    const userInfo = JSON.parse(localStorage.getItem('usersCurrentInfo'))
    if (!userInfo) {
      this.$router.push('/login')
    }
    else {
      if (userInfo.level === '0') {
        this.$router.push('/')
        this.$message({
          message: '您无法使用此功能，请先进行车载应用开发用户认证。',
          type: 'error'
        })
      }
      else {
        if (userInfo.source === '1') {
          const res = await isShowTadSim({ phone: userInfo.phone })
          if (res.code === 0) {
            if (res.data) {
              this.isShowTadSim = true
            }
          }
          else {
            this.excess = '2'
          }
        }
        this.excess = '2'
        await this.getLabel()
        await this.getList()
      }
    }
  },
  methods: {
    autofocusDialogRef(targetRef) {
      this.$refs[targetRef].focus()
    },

    selectTemplate(templateId, template) {
      // console.log('selectTemplate', templateId, template)
      this.selectedTemplate = template
    },
    createTemplate() {
      console.log('Current selectedTemplate:', this.selectedTemplate)
      if (this.selectedTemplate === null || this.selectedTemplate.id === -1) {
        this.$router.push({ path: '/major/editor' })
      }
      else {
        this.$router.push({
          path: '/major/editor',
          query: {
            templateId: this.selectedTemplate.id
          }
        })
      }
    },
    async openSelectTemplateDialog() {
      this.templateGroups = []
      this.loadTemplateFlag = true

      const data = {
        page: 1,
        pageSize: 100
      }
      const res = await selectAppModel(data)
      this.loadTemplateFlag = false
      if (res.code === 0) {
        const templateApp = res.data.records.filter(item => item.type === 1)
        templateApp.unshift({ id: -1, appName: '空模板', type: 1 })
        const exampleApp = res.data.records.filter(item => item.type === 2)
        this.templateGroups.push({ id: 1, name: '模板', options: templateApp })
        this.templateGroups.push({ id: 2, name: '应用示例', options: exampleApp })
        this.selectModelDialogVisible = true
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    async getLabel() {
      const data = {
        status: 1,
        tagGroupId: '1040925626048364544',
        pageSize: 1000
      }
      const res = await getLabel(data)
      if (res.code === 0) {
        this.options = res.data.dataList
      }
    },
    // 阶段状态,开发状态：0:开发中、1:开发完成；SIL测试状态：10:等待测试、11:测试中、12:运行失败、13:测试完成-通过、14:测试完成-不通过；HIL测试状态：20:等待测试、22：测试中、22:测试完成-通过、23:测试完成-不通过
    getStageStatusName(value) {
      console.log(value)
      let stageName = ''
      switch (value) {
        case '0':
          stageName = '开发中'
          break
        case '10':
          stageName = 'SIL测试-等待测试'
          break
        case '11':
          stageName = 'SIL测试-测试中'
          break
        case '12':
          stageName = 'SIL测试-运行失败'
          break
        case '13':
          stageName = 'SIL测试-测试通过'
          break
        case '14':
          stageName = 'SIL测试-测试不通过'
          break
        case '20':
          stageName = 'HIL测试-等待测试'
          break
        case '21':
          stageName = 'HIL测试-测试中'
          break
        case '22':
          stageName = 'HIL测试-测试通过'
          break
        case '23':
          stageName = 'HIL测试-测试不通过'
          break
        case '30':
          stageName = '车辆测试-等待测试'
          break
        case '31':
          stageName = '车辆测试-测试中'
          break
        case '32':
          stageName = '车辆测试-测试通过'
          break
        case '33':
          stageName = '车辆测试-测试不通过'
          break
        case '40':
          stageName = '发布-等待发布'
          break
        case '41':
          stageName = '发布-通过'
          break
        case '42':
          stageName = '发布-不通过'
          break
      }
      return stageName
    },
    // 移动目录操作
    async determineMoveCatalogue() {
      const res = await appMove({ id: this.catalogueFrom.id, catalogueId: this.catalogueFrom.catalogueRadio })
      if (res.code === 0) {
        this.$message({
          message: '移动成功！',
          type: 'success'
        })
        this.moveCatalogue()
        this.getList()
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    // 取消移动目录操作
    cancelMoveCatalogue() {
      this.moveCatalogue()
    },
    moveCatalogue() {
      this.catalogueFrom.id = ''
      this.catalogueFrom.catalogueRadio = ''
      this.catalogueFrom.name = ''
      this.movCatalogueDialogVisible = false
    },
    // 打开移动到目录页面
    changeMoveCatalogueDialogVisible(item) {
      this.catalogueFrom.id = item.id
      this.catalogueFrom.name = item.name
      this.movCatalogueDialogVisible = true
      this.selectCatalogue()
    },
    updateCatalogue(e) {
      this.catalogueFrom.catalogueRadio = e
    },
    // 查询目录
    async selectCatalogue() {
      const res = await selectCatalogue()
      if (res.code === 0) {
        this.catalogueLsit = res.data
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    cancelCatalogueFunction() {
      this.addCatalogueForm.catalogueName = ''
      this.addCatalogueDialog = false
    },
    async addCatalogue() {
      const res = await addCatalogue(this.addCatalogueForm)
      if (res.code === 0) {
        this.$message({
          message: '创建成功！',
          type: 'success'
        })
        this.cancelCatalogueFunction()
        this.getList()
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    // 添加目录
    addCatalogueFunction(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addCatalogue()
        }
        else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 删除方法
    async delFunction(value) {
      let res
      if (value.type === '0') {
        res = await delCatalogue({ id: value.id })
      }
      else {
        res = await delApp({ id: value.id })
      }
      console.log(res)
      if (res.code === 0) {
        this.$message({
          message: '删除成功！',
          type: 'success'
        })
        await this.getList()
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    // 时间转换
    gainDataTime(value) {
      return getDataTime(value)
    },
    // 获取列表
    async getList() {
      // const loading = this.$loading({
      //   lock: true,
      //   text: 'Loading',
      //   spinner: 'el-icon-loading',
      //   background: '#F6F8FC'
      // })
      const res = await getProfessionalLevelLsit({ catalogueName: this.appName })
      if (res.code === 0) {
        // const msg = this.appName === '' ? '没有数据！' : '未搜索到相关内容！'
        this.list = res.data
        console.log(this.list)
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    // 应用克隆
    cloneSceneConfirm(id) {
      const that = this
      that.$confirm('是否克隆当前应用', '确认信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
        confirmButtonClass: 'confirmButtonClass',
        cancelButtonClass: 'cancelButtonClass',
        closeOnClickModal: false
      })
        .then(() => {
          that.cloneScene(id)
        })
        .catch(action => {
        })
    },
    async cloneScene(id) {
      const res = await appCloneScene({ id: id })
      if (res.code === 0) {
        this.$message({
          message: '克隆成功！',
          type: 'success'
        })
        this.getList()
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    async catalogueUpdateSubmit() {
      const catalogueProperties = this.catalogueProperties
      let res
      if (catalogueProperties.type === '0') {
        res = await catalogueUpdate({
          id: catalogueProperties.id,
          catalogueName: catalogueProperties.newName,
          catalogueDesc: catalogueProperties.newDescribes,
          logoKey: catalogueProperties.newLogoKey,
          logoUrl: catalogueProperties.newLogoUrl
        })
      }
      else {
        res = await addorupdata({
          appType: catalogueProperties.appType,
          id: catalogueProperties.id,
          appName: catalogueProperties.newName,
          appDesc: catalogueProperties.newDescribes,
          logoKey: catalogueProperties.newLogoKey,
          logoUrl: catalogueProperties.newLogoUrl
        }, '2')
      }
      if (res.code === 0) {
        this.$message({
          message: '修改成功！',
          type: 'success'
        })
        this.cancelCatalogueUpdate()
        this.getList()
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    catalogueUpdate(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.catalogueUpdateSubmit()
        }
        else {
          console.log('error submit!!')
          return false
        }
      })
    },
    cancelCatalogueUpdate() {
      this.fileList = []
      this.catalogueProperties = {
        appType: '',
        id: '',
        type: '',
        newName: '',
        newDescribes: '',
        newLogoKey: '',
        newLogoUrl: ''
      }
      this.cataloguePropertiesDialogVisible = false
    },
    cataloguePropertiesView(item) {
      // debugger
      this.catalogueProperties.id = item.id
      this.catalogueProperties.appType = item.appType
      this.catalogueProperties.newName = item.name
      this.catalogueProperties.type = item.type
      this.catalogueProperties.newDescribes = item.describes
      if (item.logoUrl !== '' && item.logoUrl !== null) {
        this.catalogueProperties.newLogoKey = item.logoKey
        this.catalogueProperties.newLogoUrl = item.logoUrl
        this.fileList = [{ name: item.logoUrl, url: item.logoUrl }]
      }
      this.cataloguePropertiesDialogVisible = true
    },
    handleRemove(file) {
      this.catalogueProperties.newLogoKey = ''
      this.catalogueProperties.newLogoUrl = ''
      this.fileList = []
      console.log(file)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.uploadDialogVisible = true
    },
    handleClose() {
    },
    async goDetails(data) {
      console.log(1)
      if (data.type === '0') {
        this.$router.push({ path: '/article/specialized', query: { id: data.id, name: this.appName }})
      }
      else {
        this.$router.push({
          path: '/major', query: { id: data.id }
        })
      }
    },
    // 共同删除弹窗
    async isDelect(item) {
      console.log(item)
      const that = this
      const res = await moduleRela({ 'id': item.id, 'dataType': item.type, 'dataId': item.id })
      if (res.code === 0) {
        if (res.data !== null) {
          const list = res.data.data.list
          let names = ''
          for (let i = 0; i < list.length; i++) {
            const moduleConfigs = list[i].moduleConfigs
            moduleConfigs.forEach((item, index) => {
              names = names + `'${item.name}'、`
            })
          }
          names = names.substring(0, names.length - 1)
          if (names !== '') {
            this.$confirm(`当前应用存在于${names}的算法配置中,删除后本应用将不再存在于以上应用的算法配置中`, '确认信息', {
              confirmButtonText: '仍然删除',
              cancelButtonText: '取消',
              type: 'warning',
              center: true,
              confirmButtonClass: 'confirmButtonClass',
              cancelButtonClass: 'cancelButtonClass',
              closeOnClickModal: false
            })
              .then(() => {
                that.delFunction(item)
              })
              .catch(action => {
              })
          }
          else {
            this.$confirm('是否删除当前信息？', '确认信息', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true,
              confirmButtonClass: 'confirmButtonClass',
              cancelButtonClass: 'cancelButtonClass',
              closeOnClickModal: false
            })
              .then(() => {
                that.delFunction(item)
              })
              .catch(action => {
              })
          }
        }
        else {
          this.$confirm('是否删除当前信息？', '确认信息', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            center: true,
            confirmButtonClass: 'confirmButtonClass',
            cancelButtonClass: 'cancelButtonClass',
            closeOnClickModal: false
          })
            .then(() => {
              that.delFunction(item)
            })
            .catch(action => {
            })
        }
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    goBackList() {
      this.getList()
    },
    goHistoricalData(id) {
      this.$router.push({ path: '/article/historicalData', query: { id: id }})
    },
    beforeUpload(file) {
      this.addResource = file
      this.fileName = file.name
      console.log(file)
      if (this.addResource.type === 'image/png' || this.addResource.type === 'image/jpg' || this.addResource.type === 'image/jpeg') {
        if (file.size < 500 * 1024) {
          this.fileList = []
          this.$message.success('正在上传')
          return true
        }
        else {
          this.$message.error('图片大小不能超过500kb')
          return false
        }
      }
      this.$message.error('文件格式有误')
      return false
    },
    async cutomUpload(data) {
      console.log(data)
      const { file } = data
      const res = await getUploadKey(0)
      const cosKey = res.data
      console.log(cosKey)
      const cosKlg = new COS({
        getAuthorization: (options, callback) => {
          callback({
            TmpSecretId: cosKey.secretId,
            TmpSecretKey: cosKey.secretKey,
            XCosSecurityToken: cosKey.token,
            ExpiredTime: cosKey.expireTime
          })
        }
      })
      const key = 'web/img/' + new Date().getTime() + '-' + file.name
      cosKlg.putObject({
        Bucket: cosKey.bucket, // 指定桶参数coskey参
        Region: cosKey.region,
        Key: key, // this.sourcePath
        ContentType: 'application/octet-stream',
        StorageClass: 'STANDARD',
        Body: file,
        onProgress: function(progressData) {
          console.log(JSON.stringify(progressData))
        }
      }, (err, data) => {
        this.$message({
          message: '上传成功！',
          type: 'success'
        })
        this.catalogueProperties.newLogoKey = key
        this.catalogueProperties.newLogoUrl = 'http://' + data.Location
        this.fileList = [{ name: file.name, url: 'http://' + data.Location }]
        console.log(this.list)
        console.log(err || data)
      })
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个图片，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    goConfiguration() {
      location.href = `${this.host}/USPSim/user-center`
    },
    checkSpecialKey(str) {
      if (typeof str !== 'undefined' && str != null && str !== '') {
        const specialKey =
    "[`~!#$^&*()=|{}':;'\\[\\].<>/?~！#￥……&*（）——|{}【】‘；：”“'。，、？]‘'"
        for (let i = 0; i < str.length; i++) {
          if (specialKey.indexOf(str.substr(i, 1)) !== -1) {
            return false
          }
        }
      }
      return true
    }
  }
}
</script>

<style scoped>
.allDirectoryHeader{
  padding-bottom: 23px;
  width: 100%;
  height: 50px;
  text-align: center;
  letter-spacing: 1px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  align-content: space-between;
}
.directoryName {
  font-size: 24px;
  color: rgb(77, 120, 255);
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 27%;
  display: block;
}
.time {
  padding-left: 1px;
  font-size: 14px;
  font-weight: 400;
  color: #999999;
}
.bottom {
  margin-top: 12px;
  margin-bottom: 13px
}
.button {
  padding: 0;
  float: right;
}
.image {
  width: 100%;
  height: 151px;
  display: block;
  border-radius: 4px;
}
.el-input__inner1 {
  width: 15vw;
}
.el-input__inner2 {
  width: 15vw;
  height: 20vh;
}
.appListCard {
  transition: all .5s;
}
.appListCard:hover {
  border:1px solid #4d78ff;
}
.alignSelf {
  align-self: center;
  display: flex;
}
.buttonClass {
  color: #4d78ff;
  border-radius: 4px;
  border:1px solid #4d78ff;
  height: 58px;
  font-size: 16px;
  align-items: center;
  display: flex;
  align-self: center;
}
.goBackButton{
  color: #ffffff;
  border-radius: 4px;
  border:1px solid #4d78ff;
  height: 58px;
  font-size: 18px;
  align-items: center;
  display: flex;
  background-color: #4d78ff
}
.pointClass {
  border-radius: 13px;
  border:1px solid #4D78FF;
  padding: 5px 11px;
  font-size: 14px;
  color: #4D78FF;
  background-color: #EEF7FF;
}
.confirmButton{
  color: #fff;
  background-color: #4d78ff;
  border-color: #4d78ff;
  width: 96px;
  height: 40px
}
.cancelButton{
  border-color: #4d78ff;
  width: 96px;
  height: 40px
}
.buttonNameClass{
  display: flex;
  align-self: center;
  font-size: 16px;
  padding-left:9px;
}
.buttonIconClass{
  font-size: 22px;
  display: flex;
  align-items: center;
}
::v-deep .el-dialog__headerbtn{
  display:none;
}
.dialog-header{
  padding-top: 50px;
}
.titleClass{
  font-size: 14px;
  font-weight: 400;
  color: #2F374B;
}
.moveDialogDiv:hover{
  overflow-y: scroll;
}
.moveDialogDiv{
  overflow: hidden;
  width: 365px;
  height: 300px;
  background: #FFFFFF;
  border: 1px solid #4d78ff;
  border-radius: 4px;
  text-align: left;
  margin: 0 auto 33px;
  white-space: nowrap;
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-button {
  display: none;
}
::-webkit-scrollbar-thumb {
  background: rgb(220 225 225 / 65%);
  cursor: pointer;
  border-radius: 4px;
}
::v-deep .el-dropdown-menu{
  padding: 3px 0 !important;
  background: #4D78FF
}
::v-deep .el-upload-list__item{
  width:80px;
  height:80px;
}
::v-deep .el-upload--picture-card{
  width:80px;
  height:80px;
  line-height:86px;
}
.cardName {
  color: #2F374B;
  font-size: 16px;
  /*display: flex;*/
  /*align-items: center;*/
  padding: 0 6px;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
  width: 180px;
}
/deep/.el-radio__input.is-checked+.el-radio__label{
  color: #4D78FF;
}
/deep/.el-radio__input.is-checked .el-radio__inner{
  background: white;
}/deep/.el-radio__inner{
   width: 16px;
   height: 16px;
 }
/deep/.el-radio__inner::after{
  width: 10px;
  height: 10px;
  background-color: #4D78FF;
}
.dropdownDiv{
  justify-content: space-between;
  display: flex;
  height:20px;
  position: absolute;
  right: 0px;
}
.bconfigurationButtonClass{
  display: flex;
  align-self: center;
  font-size: 16px;
}
</style>
